module.exports = __webpack_public_path__ + "./images/8bd362ca3509490c1083c7929da1dad8.webp";